import { useEffect } from 'react'
import { useAppDispatch } from '../../store'
import { collection, onSnapshot, orderBy, query, limit } from 'firebase/firestore'
import { Collections } from 'pure-js/libs/Collections'
import { InAppNotification } from 'pure-js/types/InAppNotification'
import { setNotifications, setLoading, setError } from '../../store/slices/inAppNotificationsSlice'
import { db } from '../../libs/Firebase'

/**
 * Subscribes to the current user's inAppNotifications subcollection via Firestore onSnapshot.
 * Replaces all notification polling. Mount once in App.tsx when userId is known.
 */
export const useInAppNotificationsListener = (userId: string | undefined) => {
  const dispatch = useAppDispatch()

  useEffect(() => {
    if (!userId) return

    dispatch(setLoading(true))

    const ref = collection(db, Collections.USERS, userId, Collections.IN_APP_NOTIFICATIONS)
    const q = query(ref, orderBy('createdAt', 'desc'), limit(50))

    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        const notifications = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data()
        })) as InAppNotification[]
        dispatch(setNotifications(notifications))
      },
      (error) => {
        console.error('inAppNotifications listener error', error)
        dispatch(setError(error.message))
      }
    )

    return () => unsubscribe()
  }, [userId, dispatch])
}
